// Returns the list of courses the current user is allowed to see in the admin course UI.
// Course admins are scoped to courses they have a CourseUser row for or a CourseGroupingUser
// grouping that contains the course; admin roles
import { OrgCapability, hasOrgCapability } from "../../shared/capabilities";

import {
  courseGroupingUserSelectors,
  courseSelectors,
  courseUserSelectors,
  createAppSelector,
} from "./base";
import { selectCurrentUserOrgRole } from "./permissions";

// see every course in the org.
export const selectAdminAccessibleCourses = createAppSelector(
  [
    courseSelectors.selectAll,
    selectCurrentUserOrgRole,
    courseUserSelectors.filterForCurrentUser,
    courseGroupingUserSelectors.filterForCurrentUser,
  ],
  (courses, orgUserRole, currentUserCourseUsers, currentUserGroupingUsers) => {
    if (hasOrgCapability(orgUserRole, OrgCapability.CAN_AUTHOR_ORG)) {
      return courses;
    }

    const accessibleCourseIds = new Set(currentUserCourseUsers.map((cu) => cu.course_id));
    const accessibleGroupingIds = new Set(
      currentUserGroupingUsers.map((gu) => gu.course_grouping_id),
    );
    return courses.filter(
      (course) =>
        accessibleCourseIds.has(course.id) ||
        (course.grouping_id != null && accessibleGroupingIds.has(course.grouping_id)),
    );
  },
);
